import styled from '@emotion/styled';
import Image, { ImageProps } from 'next/image';
import { Person, Work } from '@mui/icons-material';

import { shouldForwardProps } from '../../utils';
import { Center } from '../../styles';

export const ProfileImageRound = styled(Image, shouldForwardProps)<ImageProps>`
    border-radius: 50%;
`;

export const ProfileImageSquare = styled(Image, shouldForwardProps)<ImageProps>`
    border-radius: 0;
`;

export const Circle = styled(Center)<{ size: number }>`
    height: ${({ size }) => size + 'px'};
    width: ${({ size }) => size + 'px'};
    padding: ${({ theme, size }) =>
        theme.spacing(
            // constants are defined, i.e. the icon size is around 20px for 40px size (half of the circle)
            1 + Math.max(0, (size - 40) / 20)
        )};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondaryDark};
`;

export const ProfileIcon = styled(Person)`
    height: 100%;
    width: 100%;
    color: ${({ theme }) => theme.colors.onSecondaryDark};
`;

export const CompanyIcon = styled(Work)`
    height: 100%;
    width: 100%;
    color: ${({ theme }) => theme.colors.onSecondaryDark};
`;
